export function darkenColor(hex: string, percent: number) {
  hex = hex.replace(/^#/, '');

  let r = parseInt(hex.slice(0, 2), 16);
  let g = parseInt(hex.slice(2, 4), 16);
  let b = parseInt(hex.slice(4, 6), 16);

  r = Math.round(r * (1 - percent / 100));
  g = Math.round(g * (1 - percent / 100));
  b = Math.round(b * (1 - percent / 100));

  //@ts-ignore
  r = r.toString(16).padStart(2, '0');
  //@ts-ignore
  g = g.toString(16).padStart(2, '0');
  //@ts-ignore
  b = b.toString(16).padStart(2, '0');

  return `#${r}${g}${b}`;
}

export function adjustColor(hex: string, percent: number) {
  hex = hex.replace(/^#/, '');
  let colorHex = hex.slice(0, 6);
  let alphaHex = hex.slice(6, 8) || 'ff';

  let r = parseInt(colorHex.slice(0, 2), 16);
  let g = parseInt(colorHex.slice(2, 4), 16);
  let b = parseInt(colorHex.slice(4, 6), 16);

  let brightness = (r * 299 + g * 587 + b * 114) / 1000;

  if (brightness > 200) {
    r = Math.round(r * (1 - (percent + 5) / 100));
    g = Math.round(g * (1 - (percent + 5) / 100));
    b = Math.round(b * (1 - (percent + 5) / 100));
  } else if (brightness > 128) {
    r = Math.round(r * (1 - percent / 100));
    g = Math.round(g * (1 - percent / 100));
    b = Math.round(b * (1 - percent / 100));
  } else {
    r = Math.round(r + (255 - r) * ((percent * 5) / 100));
    g = Math.round(g + (255 - g) * ((percent * 5) / 100));
    b = Math.round(b + (255 - b) * ((percent * 5) / 100));
  }

  //@ts-ignore
  r = r.toString(16).padStart(2, '0');
  //@ts-ignore
  g = g.toString(16).padStart(2, '0');
  //@ts-ignore
  b = b.toString(16).padStart(2, '0');

  return `#${r}${g}${b}${alphaHex}`;
}

export function blendColorWithBackground(
  hexColorWithAlpha: string,
  backgroundColor: string = '#FFFFFF'
) {
  hexColorWithAlpha = hexColorWithAlpha.replace(/^#/, '');
  backgroundColor = backgroundColor.replace(/^#/, '');

  let r1 = parseInt(hexColorWithAlpha.slice(0, 2), 16);
  let g1 = parseInt(hexColorWithAlpha.slice(2, 4), 16);
  let b1 = parseInt(hexColorWithAlpha.slice(4, 6), 16);
  let a1 = parseInt(hexColorWithAlpha.slice(6, 8), 16) / 255; // Alpha (0 - 1)

  let r2 = parseInt(backgroundColor.slice(0, 2), 16);
  let g2 = parseInt(backgroundColor.slice(2, 4), 16);
  let b2 = parseInt(backgroundColor.slice(4, 6), 16);

  let r = Math.round(r1 * a1 + r2 * (1 - a1));
  let g = Math.round(g1 * a1 + g2 * (1 - a1));
  let b = Math.round(b1 * a1 + b2 * (1 - a1));

  //@ts-ignore
  r = r.toString(16).padStart(2, '0');
  //@ts-ignore
  g = g.toString(16).padStart(2, '0');
  //@ts-ignore
  b = b.toString(16).padStart(2, '0');

  return `#${r}${g}${b}`;
}

export function getOppositeColor(hex: string): string {
  hex = hex.replace(/^#/, '');

  let r = parseInt(hex.slice(0, 2), 16);
  let g = parseInt(hex.slice(2, 4), 16);
  let b = parseInt(hex.slice(4, 6), 16);

  r = 255 - r;
  g = 255 - g;
  b = 255 - b;

  let rHex = r.toString(16).padStart(2, '0');
  let gHex = g.toString(16).padStart(2, '0');
  let bHex = b.toString(16).padStart(2, '0');

  return `#${rHex}${gHex}${bHex}`;
}

export function applyTransparency(hex: string, alpha: number): string {
  hex = hex.replace(/^#/, '');

  let r = parseInt(hex.slice(0, 2), 16);
  let g = parseInt(hex.slice(2, 4), 16);
  let b = parseInt(hex.slice(4, 6), 16);

  if (alpha < 0) alpha = 0;
  if (alpha > 1) alpha = 1;

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export function hexToFilter(hex: string): string {
  // Remove the hash at the start if it's there
  hex = hex.replace(/^#/, '');

  // Parse the r, g, b values
  let r = parseInt(hex.slice(0, 2), 16);
  let g = parseInt(hex.slice(2, 4), 16);
  let b = parseInt(hex.slice(4, 6), 16);

  // Convert to HSL
  let { h, s, l } = rgbToHsl(r, g, b);

  // Calculate the filter values
  let invert = l > 0.5 ? 0 : 1;
  let sepia = 1;
  let saturate = s * 1000;
  let hueRotate = h;

  return `invert(${invert}) sepia(${sepia}) saturate(${saturate}%) hue-rotate(${hueRotate}deg)`;
}

function rgbToHsl(r: number, g: number, b: number) {
  r /= 255;
  g /= 255;
  b /= 255;
  let max = Math.max(r, g, b);
  let min = Math.min(r, g, b);
  let h = 0,
    s,
    l = (max + min) / 2;

  if (max === min) {
    h = s = 0; // achromatic
  } else {
    let d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
    }
    h /= 6;
  }

  return { h: h * 360, s: s, l: l };
}
